import { useTranslation } from 'react-i18next';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import ListItem from '@mui/material/ListItem';

import { provideFlagIcon } from './IconProvider';
import './LanguageSelector.css';
import { Language, getAvailableLanguages } from './translateFunctions';

const LanguageItem = ({ language, page }: { language: Language; page: string }) => {
  const { t, i18n } = useTranslation();

  async function languageChange() {
    await i18n.changeLanguage(language.code);
    localStorage.setItem('language', language.code);
  }

  return (
    <ListItem
      disablePadding
      className="language-selector-list-item"
      onClick={languageChange}
      data-qa-element-id={`language-selector-language-${language.code}`}
    >
      <span
        className={
          language.code === i18n.language
            ? page === 'profile'
              ? 'language-selector-list-item-selected-profile'
              : 'language-selector-list-item-selected-main'
            : 'language-selector-list-item-nonselected'
        }
      >
        <img className="language-selector-list-icon" src={provideFlagIcon(language.code)} />
        <span>{t(language.name)}</span>
      </span>
    </ListItem>
  );
};

const LanguageSelector = ({ page }: { page: string }) => {
  const availableLanguages: Language[] = getAvailableLanguages();

  return (
    <List
      component={Stack}
      direction="row"
      className={page === 'profile' ? 'language-selector-list-profile' : 'language-selector-list-login'}
    >
      {availableLanguages.map((lang) => (
        <LanguageItem
          language={lang}
          page={page}
          key={lang.code}
          data-qa-element-id={`language-selector-language-${lang.code}`}
        />
      ))}
    </List>
  );
};

export default LanguageSelector;
